/**
 * LA PESTAÑA SOPORTE DE LA FICHA: QUÉ SE MEZCLA Y QUÉ SE ENVÍA (hotfix 3/11)
 *
 * Entrando con `?tab=soporte` y la ventana del doble factor viva, la ficha pedía a la vez sus datos
 * (GET, sin credenciales) y los de Soporte (POST con la ventana). Soporte solía llegar ANTES, y la
 * carga de la ficha SUSTITUÍA el estado entero: las credenciales desaparecían de la pantalla con
 * Soporte marcado como desbloqueado. Lo que se tecleara o vaciara ahí podía acabar guardado.
 *
 * Tres reglas, puras para poder probarlas:
 *   · la carga de la ficha MEZCLA: conserva los campos de Soporte que ya hubiera, si son de la misma
 *     persona;
 *   · «Soporte cargado bien en esta apertura»: la respuesta de Soporte llegó y todos sus campos siguen
 *     en el estado;
 *   · sin eso, los campos de Soporte NO se envían al guardar.
 *
 * Los campos son los de Persona_Controller.getDatosSoporte (services/camposSoporte.js en el servidor).
 */

export const CAMPOS_SOPORTE = [
  'password_nas', 'password_m365', 'password_anydesk', 'password_admin_equipo', 'password_usuario_equipo', 'bit_locker',
  'usuario_nas', 'conexion_remota', 'conexion_remota_movil', 'observaciones_soporte', 'ruskdesk_pc', 'ruskdesk_movil',
];

const idDe = (p) => (p ? String(p.Id ?? p.id ?? '') : '');

/** Los campos de Soporte que hay en `datos` (definidos). */
export function soporteDe(datos) {
  const r = {};
  for (const c of CAMPOS_SOPORTE) if (datos && datos[c] !== undefined) r[c] = datos[c];
  return r;
}

/**
 * El estado tras la carga de la ficha: lo recibido, más los campos de Soporte que el estado ya tenía
 * —sólo si es la MISMA persona: al pasar a otra ficha, lo de la anterior no se arrastra—.
 */
export function mezclarCargaFicha(previo, recibida) {
  const misma = idDe(previo) !== '' && idDe(previo) === idDe(recibida);
  return { ...recibida, ...(misma ? soporteDe(previo) : {}) };
}

/**
 * ¿Están en el estado, intactos, los campos que devolvió Soporte en esta apertura? `cargado` es la
 * lista de campos de la respuesta (o null si no ha llegado). Un campo que la respuesta traía y el
 * estado ya no tiene es justo lo que dejaba la carrera.
 */
export function soporteCargadoBien({ cargado, personaData }) {
  if (!Array.isArray(cargado)) return false;
  return cargado.every((c) => personaData && personaData[c] !== undefined);
}

/** Sin Soporte cargado bien, sus campos no viajan al guardar. Devuelve una copia. */
export function quitarSoporteSiNoCargado(payload, cargadoBien) {
  const copia = { ...payload };
  if (!cargadoBien) for (const c of CAMPOS_SOPORTE) delete copia[c];
  return copia;
}
